module.exports = __webpack_public_path__ + "img/KlikA2C.46bb202c.png";